import { render, staticRenderFns } from "./BimEngineeringChangeItem.vue?vue&type=template&id=8df577d0"
import script from "./BimEngineeringChangeItem.vue?vue&type=script&lang=js"
export * from "./BimEngineeringChangeItem.vue?vue&type=script&lang=js"
import style0 from "./BimEngineeringChangeItem.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports